import React from 'react'
import { withTheme } from 'styled-components'

import { URL_CONST } from 'utils/urlConsts'

import Button from 'components/lib/DesignSystem/Button'
import Checkbox from 'components/lib/DesignSystem/Checkbox'
import Modal from 'components/lib/DesignSystem/Modal'

class Reintegration extends React.Component {
  state = {
    closed: false,
    dontShowAnyMore: false,
  }

  handlerOnClose = () => {
    if (!this.state.closed) {
      if (this.state.dontShowAnyMore) {
        // close popup and call api to save user value of not showing this popup again
        this.handlerLastSeenSave()
      } else {
        this.handleContinue()
      }
    }
  }

  handlerLastSeenSave = () => {
    this.setState({ closed: true })
    this.props.saveDontShowReIntegration()
  }

  handleContinue = () => {
    this.setState({ closed: true })
  }

  handleCheckBox = () => {
    const currentDontShowAnyMoreFlag = this.state.dontShowAnyMore
    this.setState({ dontShowAnyMore: !currentDontShowAnyMoreFlag })
  }

  handlerLearnMore = () => {
    window.open(
      'https://support.ironscales.com/hc/en-us/articles/360002496352-Office-365-Integration-Guide',
      '_blank'
    )
  }

  handleSettingsRedirect = () => {
    this.setState({ closed: true })
    this.props.history.push(URL_CONST.settings.emailServer)
  }

  render() {
    const { closed, dontShowAnyMore } = this.state
    const { isMaster, showReintegratePopup } = this.props

    if (closed || !showReintegratePopup || isMaster) return ''

    return (
      <Modal
        open
        width="540px"
        onClose={this.handlerOnClose}
        title="Re-Integration required"
        id="Reintegration_Modal"
        footer={
          <>
            <Button
              text="Continue"
              styleType="secondary"
              className="mr"
              onClick={this.handlerOnClose}
              id="Reintegration_Modal_Close_Btn"
            />
            <Button
              text="Read More"
              onClick={this.handlerLearnMore}
              id="Reintegration_Modal_Learn_More_Btn"
            />
          </>
        }
      >
        <>
          <img src="/static/webapp/images/new-release.svg" className="ma db" />
          <div style={{ marginTop: '32px' }}>
            We deployed a new feature that{' '}
            <span onClick={this.handleSettingsRedirect} className="link-new-design">
              requires your re-authorization.
            </span>{' '}
            We would appreciate it if you can authorize your Office 365 integration once again. If
            you have any questions please contact us at{' '}
            <a href="mailto:support@ironscales.com">support@ironscales.com</a>
            <Checkbox
              className="mt"
              checked={dontShowAnyMore}
              onChange={this.handleCheckBox}
              id="Reintegration_Modal_Dont_Show_Checkbox"
              label="Do not show me this message again"
            />
          </div>
        </>
      </Modal>
    )
  }
}

export default withTheme(Reintegration)
